import theme from 'config/theme';

export default {
  textfield: {
    width: '100%',
    borderRadius: '4px',
    boxShadow: 'none',
    height: '40px',

    '& .MuiInputBase-input': {
      padding: '10px 12px',
      color: theme.palette.grays.gray700,
    },
    '& .MuiInputBase-root': {
      borderRadius: '4px',
      fontSize: '0.875rem',
      width: '100%',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.grays.gray300}`,
      },
      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
          border: 1,
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.8,
        backgroundColor: `transparent`,
        '& .MuiInputBase-input': {
          backgroundColor: `transparent`,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },

        '&:hover': {
          backgroundColor: `transparent`,
        },
      },
    },
  },

  errorTextInput: {
    '& .MuiInputBase-root': {
      fontSize: '0.875rem',
      width: '100%',

      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.reds.codingRed200}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },

      backgroundColor: `${theme.palette.grays.lightestGray}`,
      '& .MuiOutlinedInput-notchedOutline': {
        boxShadow: `${theme.customShadows.errorShadow}`,
        borderColor: `${theme.palette.reds.codingRed200}`,
      },
    },
  },
  popper: {
    '.MuiPaper-root': {
      '& .MuiPickersToolbar-root': {
        display: 'none',
      },
      '& .MuiPickersCalendarHeader-label': {
        color: theme.palette.grays.gray600,
        fontWeight: 500,
        fontSize: '1rem',
      },
      '& .MuiDayCalendar-weekDayLabel': {
        color: theme.palette.grays.gray900,
      },
      '& .MuiPickersDay-root': {
        fontSize: '0.875rem',
        color: theme.palette.grays.grey700,
        '&:hover': {
          backgroundColor: theme.palette.blues.primaryBlue200,
        },
        ':first-of-type': {
          color: theme.palette.grays.gray400,
        },
      },
      '& .Mui-selected': {
        color: '#fff!important',
        backgroundColor: theme.palette.blues.primaryBlue500,
        '&:hover': {
          color: '#fff',
          backgroundColor: theme.palette.blues.primaryBlue700,
        },
      },
    },
  },
};
